import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function AGB() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Update page title
    document.title = "AGB - Allgemeine Geschäftsbedingungen | reputrust.ai";
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-600 selection:bg-tron-primary/30 selection:text-[#0F172A]">
      <Header />

      <div className="pt-32 pb-20 relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-96 h-96 bg-tron-primary/10 rounded-full blur-[100px] animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-tron-secondary/10 rounded-full blur-[100px] animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>

        {/* Content */}
        <div className="max-w-[900px] mx-auto px-6 relative z-10">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200">
            <h1 className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-8 border-b border-slate-200 pb-6" style={{ fontFamily: 'Inter Tight, sans-serif' }}>
              Allgemeine Geschäftsbedingungen (AGB)
            </h1>

            <div className="prose prose-slate prose-lg max-w-none" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 1 Geltungsbereich</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") der SMC Simon Müller Consulting e.K. (nachfolgend „Anbieter") gelten für alle Verträge über die Nutzung der Software-as-a-Service-Plattform „reputrust.ai" (nachfolgend „Plattform"), die zwischen dem Anbieter und einem Kunden (nachfolgend „Kunde") geschlossen werden.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen des Kunden werden nur dann und insoweit Vertragsbestandteil, als der Anbieter ihrer Geltung ausdrücklich schriftlich zugestimmt hat.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 2 Vertragsgegenstand</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Der Anbieter stellt dem Kunden eine cloudbasierte Software-Plattform zur Verfügung, die es ermöglicht, Kundenbewertungen zu generieren, zu verwalten und automatisiert zu beantworten sowie Social-Media-Beiträge zu erstellen und Google-Unternehmensprofile zu verwalten.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Der Anbieter schuldet die Bereitstellung der Plattform in ihrer jeweils aktuellen Version. Der Anbieter ist berechtigt, die Plattform weiterzuentwickeln und zu verbessern.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (3) Der Anbieter schuldet keine Verfügbarkeit von 100%. Der Anbieter bemüht sich jedoch um eine möglichst hohe Verfügbarkeit der Plattform.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 3 Vertragsschluss</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Der Vertragsschluss erfolgt durch Registrierung des Kunden auf der Plattform und Auswahl eines Preismodells.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Mit der Registrierung gibt der Kunde ein verbindliches Angebot zum Abschluss eines Nutzungsvertrages ab. Der Anbieter nimmt dieses Angebot durch Freischaltung des Kundenkontos an.
              </p>


              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 4 Preise und Zahlungsbedingungen</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Es gelten die zum Zeitpunkt der Bestellung auf der Plattform angegebenen Preise. Alle Preise verstehen sich zuzüglich der gesetzlichen Umsatzsteuer.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Die Abrechnung erfolgt monatlich oder jährlich im Voraus, je nach gewähltem Preismodell.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (3) Die Zahlung erfolgt per Kreditkarte, Lastschrift oder einem anderen auf der Plattform angebotenen Zahlungsmittel.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (4) Der Anbieter ist berechtigt, die Preise mit einer Ankündigungsfrist von 4 Wochen zu ändern. Der Kunde hat in diesem Fall ein Sonderkündigungsrecht.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 5 Nutzungsrechte</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Der Anbieter räumt dem Kunden für die Dauer des Vertrages ein nicht ausschließliches, nicht übertragbares und nicht unterlizenzierbares Recht zur Nutzung der Plattform ein.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Der Kunde ist nicht berechtigt, die Plattform zu dekompilieren, zu disassemblieren oder anderweitig zurückzuentwickeln.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (3) Der Kunde darf die Plattform nur für eigene geschäftliche Zwecke nutzen. Eine Weitergabe an Dritte ist nicht gestattet.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 6 Pflichten des Kunden</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Der Kunde ist verpflichtet, seine Zugangsdaten geheim zu halten und vor dem Zugriff durch Dritte zu schützen.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Der Kunde ist verpflichtet, die Plattform nur im Rahmen der geltenden Gesetze und Vorschriften zu nutzen.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (3) Der Kunde ist verpflichtet, keine Inhalte hochzuladen oder zu verbreiten, die gegen geltendes Recht verstoßen oder Rechte Dritter verletzen.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (4) Der Kunde stellt den Anbieter von allen Ansprüchen Dritter frei, die aufgrund einer rechtswidrigen Nutzung der Plattform durch den Kunden entstehen.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 7 Datenschutz und Datensicherheit</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Der Anbieter verarbeitet personenbezogene Daten des Kunden im Rahmen der geltenden Datenschutzgesetze, insbesondere der DSGVO.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Nähere Informationen zur Datenverarbeitung finden sich in der Datenschutzerklärung des Anbieters.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (3) Der Anbieter trifft angemessene technische und organisatorische Maßnahmen zum Schutz der Daten des Kunden.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 8 Vertragslaufzeit und Kündigung</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Der Vertrag wird auf unbestimmte Zeit geschlossen.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Der Vertrag kann von beiden Parteien mit einer Frist von einem Monat zum Ende des jeweiligen Abrechnungszeitraums gekündigt werden.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (3) Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (4) Die Kündigung bedarf der Textform (z.B. E-Mail).
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 9 Gewährleistung</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Der Anbieter gewährleistet, dass die Plattform die vertraglich vereinbarte Beschaffenheit aufweist und frei von Rechts- und Sachmängeln ist.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Der Anbieter ist berechtigt, Mängel durch Nachbesserung oder Ersatzlieferung zu beheben.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (3) Schlägt die Nacherfüllung fehl, kann der Kunde nach seiner Wahl Minderung verlangen oder vom Vertrag zurücktreten.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 10 Haftung</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für die Verletzung von Leben, Körper oder Gesundheit.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Bei leichter Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten). In diesem Fall ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (3) Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">§ 11 Schlussbestimmungen</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (2) Erfüllungsort und ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist der Sitz des Anbieters, sofern der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                (3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen hiervon unberührt.
              </p>

              <p className="text-slate-600 leading-relaxed mb-4 mt-8">
                <strong className="text-[#0F172A]">Stand: Januar 2025</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
